
import {
  CHANGE_PAGE_REQUEST, CHANGE_PAGE_SUCCESS, LOAD_RESPONSES_ERROR, LOAD_RESPONSES_REQUEST,
  LOAD_RESPONSES_SUCCESS
} from "./responses-action-types";

export const loadResponsesRequest = ({page, clean, whoMounted}) => ({ type: LOAD_RESPONSES_REQUEST, page, clean, whoMounted });
export const loadResponsesSuccess = ({ responses, page, totalPages, clean }) => (
  { type: LOAD_RESPONSES_SUCCESS, responses, page, totalPages, clean }
  );
export const loadResponsesError = error => ({ type: LOAD_RESPONSES_ERROR, error });

export const changePageRequest = ({ page, previous, next }) => ({ type: CHANGE_PAGE_REQUEST, page, previous, next });
export const changePageSuccess = page => ({ type: CHANGE_PAGE_SUCCESS, page });


// WEBPACK FOOTER //
// ./src/modules/responses/responses-action-creators.js